import { useLayoutEffect } from "react";
import type { RefObject } from "react";

/**
 * Колко реда от името на продукта се събират над цената в кутийка с
 * избрана височина (`ItemCard` `sizing="fixed"`). Всички кутийки в
 * решетката са еднакви, затова се мери първата и `--name-lines` се пише на
 * решетката — без прерисуване. Кегелът зависи от ширината на кутийката
 * (container query), затова редовата височина е от DOM. Наново при нов
 * размер на решетката или на първата кутийка (дръжките, ширината на екрана)
 * и при `measureKey` (размерът от дръжките, първият продукт).
 */
export const useCatalogNameLines = (
  gridRef: RefObject<HTMLElement | null>,
  enabled: boolean,
  measureKey: string,
) => {
  useLayoutEffect(() => {
    const grid = gridRef.current;
    if (!grid || !enabled) return;
    const fit = () => {
      const nameRow = grid.querySelector<HTMLElement>("[data-card-name-row]");
      const name = nameRow?.querySelector<HTMLElement>("[data-card-name]");
      if (!nameRow || !name) return;
      const lineHeight = parseFloat(getComputedStyle(name).lineHeight);
      if (!(lineHeight > 0)) return;
      const lines = Math.max(1, Math.floor((nameRow.clientHeight + 0.5) / lineHeight));
      grid.style.setProperty("--name-lines", String(lines));
    };
    fit();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(fit);
    observer.observe(grid);
    const firstNameRow = grid.querySelector("[data-card-name-row]");
    if (firstNameRow) observer.observe(firstNameRow);
    return () => {
      observer.disconnect();
      grid.style.removeProperty("--name-lines");
    };
  }, [gridRef, enabled, measureKey]);
};
